export default __webpack_public_path__ + "static/media/Livingroom2.705fd87a.png";